import { render, staticRenderFns } from "./OrderByHeader.vue?vue&type=template&id=2b19f503"
import script from "./OrderByHeader.vue?vue&type=script&lang=js"
export * from "./OrderByHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports